import { QueueStatuses } from 'components/tables/TaskTable/QueueDetails/queueDetails.types';
import { UserRoleInfo } from 'store/staffs/staffs.types';

export interface QueueTypes {
  // Whether provider can take a task from queue
  canTakeNext: boolean;
  // Whether this is a preview or assigned task
  mode: 'preview' | 'assigned';
  // Provider's current queue shift (if on one)
  providerShift: { endTime: string; startTime: string } | null;
  // Queue statistics
  stats: {
    appointmentsInQueue: number; // Total in queue for provider's states
  };
  task: {
    _id?: string;
    appointmentInfo?: {
      appointmentType: {
        _id: string;
        displayName: string;
      };
    };
    assignedAt?: string;
    assignedToInfo?: {
      _id: string;
      fullName: string;
      name: string;
      profileImage?: string;
      userRoleInfo: UserRoleInfo;
    };
    createdAt?: string;
    doctorInfo?: {
      _id: string;
      fullName: string;
      name: string;
    };
    patientInfo?: {
      dob: string;
      name: string;
      state: string;
    };
    /** Visit-scoped provider gender preference set at booking time. Absent means no preference. */
    preferredProviderGender?: 'female' | 'male';
    // PREVIEW MODE
    statusInfo: {
      createdAt: string; // When it entered this status
      status: QueueStatuses; // e.g., 'in_queue'
    };
  } | null;
}

interface InitialQueueState {
  loading: boolean;
  onGetQueueDetails?: () => void;
  queueInfo: { taskInProgress: boolean };
  queueScheduleDetails: QueueTypes | null;
}

export const initialState: InitialQueueState = {
  loading: false,
  queueInfo: { taskInProgress: false },
  queueScheduleDetails: null
};
